import { stat } from "fs";

const state = {
	articleCodeUniqueValueCheck: {},
	CategoryCheckInAM: {
		empty: false,
		full: false
	},
	SubCategoryCheckInAM: {
		empty: false,
		full: false
	}
};

const mutations = {
	SET_ARTICLE_CODE_UNIQUE_VALUE_CHECK(state, payload) {
		state.articleCodeUniqueValueCheck[payload] = null;
	},
	SET_CATEGORY_CHECK_IN_AM(state, payload) {
		state.CategoryCheckInAM[payload] = true;
	},
	SET_SUB_CATEGORY_CHECK_IN_AM(state, payload) {
		state.SubCategoryCheckInAM[payload] = true;
	},
	DELETE_PROP_ARTICLE_CODE_UNIQUE_VALUE_CHECK(state, payload) {
		delete state.articleCodeUniqueValueCheck[payload];
	},
	RESET_CATEGORY_CHECK_IN_AM(state) {
		state.CategoryCheckInAM.empty = false;
		state.CategoryCheckInAM.full = false;
	},
	RESET_SUB_CATEGORY_CHECK_IN_AM(state) {
		state.SubCategoryCheckInAM.empty = false;
		state.SubCategoryCheckInAM.full = false;
	},
	RESET_ARTICLE_CODE_UNIQUE_VALUE_CHECK(state) {
		state.articleCodeUniqueValueCheck = {};
	}
};

const actions = {
	updateArticleCodeUniqueValueCheck({ commit }, payload) {
		commit("SET_ARTICLE_CODE_UNIQUE_VALUE_CHECK", payload);
	},
	deletePropFromArticleCodeUniqueValueCheck({ commit }, payload) {
		commit("DELETE_PROP_ARTICLE_CODE_UNIQUE_VALUE_CHECK", payload);
	},
	UpdateCategoryCheckInAM({ commit }, payload) {
		commit("SET_CATEGORY_CHECK_IN_AM", payload);
	},
	UpdateSubCategoryCheckInAM({ commit }, payload) {
		commit("SET_SUB_CATEGORY_CHECK_IN_AM", payload);
	},
	resetCategoryCheckInAM({ commit }) {
		commit("RESET_CATEGORY_CHECK_IN_AM");
	},
	resetSubCategoryCheckInAM({ commit }) {
		commit("RESET_SUB_CATEGORY_CHECK_IN_AM");
	},
	resetArticleCodeUniqueValueCheck({ commit }) {
		commit("RESET_ARTICLE_CODE_UNIQUE_VALUE_CHECK");
	}
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};
